import styled from 'styled-components';

const StageTitle = styled.h5`
  font-size: 16px;
  font-weight: 300;
`;
export default StageTitle;
